import { render, staticRenderFns } from "./pageConfigPop.vue?vue&type=template&id=6cdfec4e&scoped=true"
import script from "./pageConfigPop.vue?vue&type=script&lang=js"
export * from "./pageConfigPop.vue?vue&type=script&lang=js"
import style0 from "./pageConfigPop.vue?vue&type=style&index=0&id=6cdfec4e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cdfec4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cdfec4e')) {
      api.createRecord('6cdfec4e', component.options)
    } else {
      api.reload('6cdfec4e', component.options)
    }
    module.hot.accept("./pageConfigPop.vue?vue&type=template&id=6cdfec4e&scoped=true", function () {
      api.rerender('6cdfec4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operationManagement/appNewRenovation/home/components/pageConfigPop.vue"
export default component.exports